// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"barcode"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M7.75 3L7.75 20M16.25 3L16.25 20M3 3H4V20H3V3ZM11.5 3H12.5V20H11.5V3ZM20 3H21V20H20V3Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-barcode')
export default class BarcodeIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'barcode',
    }
  }
}
